import styled from "styled-components";

export const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  height: ${(props) => props.height}px;
  overflow: hidden;
  border-radius: 1px;
  background: #09090a;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  cursor: ${(props) => (props.$hasVideoUrl ? "pointer" : "default")};
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  pointer-events: ${(props) => (props.$hasVideoUrl ? "auto" : "none")};

  /* NOVO: CSS containment */
  contain: layout style paint;
  will-change: transform;

  &:hover .generate-button {
    transform: ${(props) =>
      props.$hasVideoUrl ? "translate(-50%, -100%)" : "translate(-50%,-50%)"};
    opacity: ${(props) => (props.$hasVideoUrl ? "1" : "0")};
  }
  &:hover .small {
    transform: ${(props) =>
      props.$hasVideoUrl ? "rotate(0deg)" : "rotate(-15deg)"};
  }
  &:hover .video-footer {
    opacity: ${(props) => (!props.$hasVideoUrl ? "1" : "0")};
  }
`;

export const VideoElement = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: ${(props) => (props.$loaded ? "1" : "0")};
  visibility: ${(props) => (props.$loaded ? "visible" : "hidden")};
  pointer-events: ${(props) => (props.$loaded ? "auto" : "none")};
  transition: opacity 0.4s ease;
  z-index: 1;
  border-radius: 12px;

  /* NOVO: Optimizacije */
  content-visibility: auto;
  will-change: opacity;
  transform: translateZ(0);
  backface-visibility: hidden;
`;

export const ImageElement = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  max-height: 600px;
  transition: opacity 0.4s ease;
  /* z-index: 1; */
  border-radius: 12px;
`;

export const IconWrapper = styled.div`
  position: absolute;
  left: 16px;
  top: 16px;
  z-index: 100;
`;

export const ThumbnailImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: ${(props) => (props.$loaded ? "0" : "1")};
  visibility: ${(props) => (props.$loaded ? "hidden" : "visible")};
  transition: opacity 0.3s ease;

  /* NOVO: Optimizacije */
  content-visibility: auto;
  will-change: opacity;
  backface-visibility: hidden;
`;

export const ThumbnailImageSmall = styled.img`
  position: absolute;
  top: 6px;
  left: 6px;
  z-index: 25;
  border-radius: 4px;
  object-fit: cover;
  transition: transform 0.3s ease;
  width: 34px;
  height: 42px;
  transform: rotate(-6.016deg);

  /* NOVO: Optimizacije */
  will-change: transform;
  backface-visibility: hidden;
`;

export const LoadingSpinner = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: ${(props) => (props.$show ? "flex" : "none")};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 5;
  height: 100%;
  width: 100%;

  /* NOVO: GPU acceleration */
  will-change: opacity;

  l-line-spinner {
    --spinner-color: white;
  }
`;

export const LoadingSpinnerBlur = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: ${(props) => (props.$show ? "flex" : "none")};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 5;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.8);
  gap: 12px;

  /* NOVO: Optimizacija - uklonjen backdrop-filter jer troši GPU */
  will-change: opacity;
  transform: translate(-50%, -50%) translateZ(0);

  l-line-spinner {
    --spinner-color: white;
  }
`;

export const RunningText = styled.div`
  color: white;
  text-align: center;
  padding: 0px 20px;

  .running-title {
    color: #fafafa;
    font-family: Figtree;
    font-size: 16px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: -0.04px;
    margin-bottom: 12px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  }

  .running-message {
    font-family: Figtree;
    font-size: 12px;
    font-weight: 400;
    letter-spacing: -0.04px;
    color: rgba(255, 255, 255, 0.9);
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  }
`;

export const Rating = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 6px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
  z-index: 3;
  backdrop-filter: blur(4px);

  /* NOVO: Optimizacija */
  will-change: transform;
  transform: translateZ(0);
`;

export const GenerateButton = styled.button`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #333;
  border: none;
  cursor: pointer;
  opacity: 0;
  transition: all 0.3s ease;
  z-index: 4;

  border-radius: 100px;
  background: linear-gradient(0deg, #66033c -47.22%, #2877d9 100%);

  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  color: #fff;
  font-family: Figtree;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: -0.04px;

  /* NOVO: Optimizacija */
  will-change: transform, opacity;
  backface-visibility: hidden;

  &:hover {
    transform: translate(-50%, -50%) scale(1.05);
  }

  @media (max-width: 768px) {
    opacity: 1;
  }
`;

export const VideoFooter = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  pointer-events: none;
  color: white;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 61.05%,
    rgba(0, 0, 0, 0.64) 100%
  );
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
  justify-content: flex-end;
  gap: 4px;
  transition: all 0.3s ease-in-out;

  /* NOVO: Optimizacija */
  will-change: opacity, transform;
`;

export const ModelName = styled.div`
  color: #fff;
  font-family: Figtree;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.07px;
  white-space: nowrap;

  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Date = styled.div`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -1px;
  white-space: nowrap;
  opacity: 0.5;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const BadgeContainer = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
`;

export const Badge = styled.span`
  border-radius: 100px;
  background: linear-gradient(0deg, #66033c -47.22%, #2877d9 100%);

  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  color: #fafafa;
  font-family: Figtree;
  font-size: 8px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: -0.04px;

  /* NOVO: Optimizacija */
  will-change: transform;
  backface-visibility: hidden;
`;

export const CollectionThumbnail = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 12px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: ${(props) => (props.$loaded ? "0" : "1")};
  visibility: ${(props) => (props.$loaded ? "hidden" : "visible")};
  filter: ${(props) => (props.$blur ? "blur(35px)" : "none")};
  transform: ${(props) => (props.$blur ? "scale(1.1)" : "scale(1)")};
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);

  /* NOVO: Optimizacije */
  content-visibility: auto;
  will-change: opacity, transform;
  backface-visibility: hidden;
`;

export const CollectionContainer = styled.div`
  width: 100%;
  max-width: 338px;
  height: 420px;
  border-radius: 12px;
  cursor: ${(props) => (props.$inProgress ? "not-allowed" : "pointer")};
  position: relative;
  overflow: hidden;
  transition: opacity 0.3s ease;

  /* NOVO: CSS containment za bolje performanse */
  contain: layout style paint;
  will-change: transform;

  @media (max-width: 470px) {
    max-width: 100%;
    height: 450px;
  }
`;
